(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop  = 0;
      this.preventReveal     = false;
      this.predictiveSearch  = this.querySelector('predictive-search');

      this.onScrollHandler     = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(d => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function initTrovaMenu() {
      document.querySelectorAll('.pm-header__trova').forEach(function (wrapper) {
        var btn = wrapper.querySelector('.pm-header__trova-btn');
        var panel = wrapper.querySelector('.pm-header__trova-panel');
        if (!btn || !panel) return;

        var closeTimer = null;

        function openMenu() {
          clearTimeout(closeTimer);
          wrapper.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        }

        function scheduleClose() {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            wrapper.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
          }, 220);
        }

        wrapper.addEventListener('mouseenter', openMenu);
        wrapper.addEventListener('mouseleave', scheduleClose);

        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (wrapper.classList.contains('is-open')) {
            clearTimeout(closeTimer);
            wrapper.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
          } else {
            openMenu();
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.pm-header__trova.is-open').forEach(function (wrapper) {
            wrapper.classList.remove('is-open');
            var b = wrapper.querySelector('.pm-header__trova-btn');
            var p = wrapper.querySelector('.pm-header__trova-panel');
            if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
            if (p) p.setAttribute('aria-hidden', 'true');
          });
        }
      });

      document.addEventListener('click', function (e) {
        document.querySelectorAll('.pm-header__trova.is-open').forEach(function (wrapper) {
          if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is-open');
            var b = wrapper.querySelector('.pm-header__trova-btn');
            var p = wrapper.querySelector('.pm-header__trova-panel');
            if (b) b.setAttribute('aria-expanded', 'false');
            if (p) p.setAttribute('aria-hidden', 'true');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTrovaMenu);
    } else {
      initTrovaMenu();
    }
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-ag-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.pm-ag-hero__audio-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var videoId = btn.getAttribute('data-video-id');
      var video = document.getElementById(videoId);
      if (!video) return;
      var isUnmuted = btn.getAttribute('data-unmuted') === 'true';
      if (isUnmuted) {
        video.muted = true;
        btn.setAttribute('data-unmuted', 'false');
        btn.setAttribute('aria-label', btn.dataset.pmI18nUnmute || 'Attiva audio video');
      } else {
        video.muted = false;
        video.volume = 0.3;
        btn.setAttribute('data-unmuted', 'true');
        btn.setAttribute('aria-label', btn.dataset.pmI18nMute || 'Disattiva audio video');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-ag-reel1"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.pm-ag-reel1__audio-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var videoId = btn.getAttribute('data-video-id');
      var video = document.getElementById(videoId);
      if (!video) return;
      var isUnmuted = btn.getAttribute('data-unmuted') === 'true';
      if (isUnmuted) {
        video.muted = true;
        btn.setAttribute('data-unmuted', 'false');
        btn.setAttribute('aria-label', btn.dataset.pmI18nUnmute || 'Attiva audio video');
      } else {
        video.muted = false;
        video.volume = 0.3;
        btn.setAttribute('data-unmuted', 'true');
        btn.setAttribute('aria-label', btn.dataset.pmI18nMute || 'Disattiva audio video');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-ag-reel2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.pm-ag-reel2__audio-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var videoId = btn.getAttribute('data-video-id');
      var video = document.getElementById(videoId);
      if (!video) return;
      var isUnmuted = btn.getAttribute('data-unmuted') === 'true';
      if (isUnmuted) {
        video.muted = true;
        btn.setAttribute('data-unmuted', 'false');
        btn.setAttribute('aria-label', btn.dataset.pmI18nUnmute || 'Attiva audio video');
      } else {
        video.muted = false;
        video.volume = 0.3;
        btn.setAttribute('data-unmuted', 'true');
        btn.setAttribute('aria-label', btn.dataset.pmI18nMute || 'Disattiva audio video');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-h2o-new-cost-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pm-hn-calc]').forEach(function (section) {
    var inputs   = section.querySelectorAll('[data-calc-input]');
    var outRisk  = section.querySelector('[data-calc-out="risk"]');
    var outProt  = section.querySelector('[data-calc-out="protection"]');
    var outDelta = section.querySelector('[data-calc-out="delta"]');

    function fmt(n) {
      return '€ ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function getVal(name) {
      var el = section.querySelector('[data-calc-input="' + name + '"]');
      return el ? (parseFloat(el.value) || 0) : 0;
    }
    function update() {
      var pump   = getVal('pump');
      var inj    = getVal('injectors');
      var tow    = getVal('tow');
      var filter = getVal('filter');
      var risk   = pump + inj + tow;
      var delta  = risk - filter;
      if (outRisk)  outRisk.textContent  = fmt(risk);
      if (outProt)  outProt.textContent  = '€ ' + Math.round(filter);
      if (outDelta) outDelta.textContent = delta > 0 ? fmt(delta) : '€ 0';
    }

    inputs.forEach(function (inp) { inp.addEventListener('input', update); });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var stick    = document.getElementById('pm-stick');
  var spacer   = document.getElementById('pm-shell-spacer');
  var scrim    = document.getElementById('pm-scrim');

  /* ── Announcement rotator ── */
  var annItems = document.querySelectorAll('.pm-ann__item');
  if (annItems.length > 1) {
    var ai = 0;
    setInterval(function () {
      annItems[ai].classList.remove('is-on');
      ai = (ai + 1) % annItems.length;
      annItems[ai].classList.add('is-on');
    }, 4200);
  }

  /* ── Stato condensato ──
     Lo shell è fuori dal flusso (position: fixed, layout/theme.liquid) e lo
     spazio in pagina lo riserva #pm-shell-spacer, ad altezza costante.
     Condensare quindi non rifluisce più la pagina: non esiste retroazione
     fra altezza dell'header e scrollY, che era la causa del lampeggio e del
     rimbalzo dello scroll (vedi commento in layout/theme.liquid).

     Lo spaziatore fa anche da sentinella. La sua altezza è quella dello
     shell ESPANSO: lo stato condensato scatta solo quando lo spazio
     riservato è già uscito dal viewport, così non si apre mai un vuoto
     fra header condensato e contenuto. */

  /* Misura dello shell espanso → --pm-shell-h (altezza dello spaziatore).
     Solo al load / font pronti / resize / ricarica sezione: mai su scroll. */
  function measureShell() {
    if (!stick) return;
    var root    = document.documentElement;
    var wasCond = stick.classList.contains('is-cond');
    root.classList.add('pm-measuring');
    if (wasCond) stick.classList.remove('is-cond');
    var h = Math.round(stick.getBoundingClientRect().height);
    if (wasCond) stick.classList.add('is-cond');
    root.classList.remove('pm-measuring');
    if (h > 0) root.style.setProperty('--pm-shell-h', h + 'px');
  }

  measureShell();
  window.addEventListener('load', measureShell);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureShell);
  document.addEventListener('shopify:section:load', measureShell);

  var rsz;
  window.addEventListener('resize', function () {
    clearTimeout(rsz);
    rsz = setTimeout(measureShell, 150);
  }, { passive: true });

  if (stick && spacer && 'IntersectionObserver' in window) {
    /* Riferimento tenuto vivo di proposito: un observer senza riferimenti
       raggiungibili è formalmente collezionabile. */
    window.pmShellObserver = new IntersectionObserver(function (entries) {
      stick.classList.toggle('is-cond', !entries[0].isIntersecting);
    }, { threshold: 0 });
    window.pmShellObserver.observe(spacer);
  } else if (stick) {
    var cond = false;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (!cond && y > stick.offsetHeight) { cond = true; stick.classList.add('is-cond'); }
      else if (cond && y < 20) { cond = false; stick.classList.remove('is-cond'); }
    }, { passive: true });
  }

  /* ── Pannelli (mega + ricerca) ── */
  var trigs  = Array.prototype.slice.call(document.querySelectorAll('[data-pm-menu]'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-pm-panel]'));
  var sgrp   = document.getElementById('pm-sgrp');
  var openId = null;

  function closeAll() {
    trigs.forEach(function (t) {
      t.classList.remove('is-open');
      t.setAttribute('aria-expanded', 'false');
    });
    panels.forEach(function (p) {
      p.classList.remove('is-on');
      p.setAttribute('aria-hidden', 'true');
    });
    if (scrim) scrim.classList.remove('is-on');
    if (sgrp) sgrp.classList.remove('is-active');
    if (openId === 'search') document.dispatchEvent(new CustomEvent('pm:search-close'));
    openId = null;
  }

  function openPanel(id) {
    if (openId === id) { closeAll(); return; }
    closeAll();
    trigs.forEach(function (t) {
      if (t.getAttribute('data-pm-menu') === id) {
        t.classList.add('is-open');
        t.setAttribute('aria-expanded', 'true');
      }
    });
    var p = document.querySelector('[data-pm-panel="' + id + '"]');
    if (p) { p.classList.add('is-on'); p.setAttribute('aria-hidden', 'false'); }
    if (scrim) scrim.classList.add('is-on');
    openId = id;
    if (sgrp) sgrp.classList.toggle('is-active', id === 'search');
    if (id === 'search') {
      setTimeout(function () {
        var sp = document.getElementById('pm-search-input');
        if (sp) sp.focus();
      }, 240);
    }
  }

  trigs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openPanel(t.getAttribute('data-pm-menu'));
    });
  });

  /* Digitare nel campo barra apre il pannello e travasa il testo */
  var barInput = document.getElementById('pm-bar-input');
  if (barInput) {
    var escalate = function () {
      if (openId === 'search') return;
      var v = barInput.value;
      openPanel('search');
      var sp = document.getElementById('pm-search-input');
      if (sp && v) {
        sp.value = v;
        sp.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };
    barInput.addEventListener('focus', escalate);
    barInput.addEventListener('input', escalate);
  }

  if (scrim) scrim.addEventListener('click', closeAll);
  if (stick) stick.addEventListener('click', function (e) { e.stopPropagation(); });
  document.addEventListener('click', closeAll);

  /* ── Menu mobile + focus trap ── */
  var mnav   = document.getElementById('pm-mnav');
  var burger = document.getElementById('pm-burger');
  var mnavX  = document.getElementById('pm-mnav-x');

  function trapFocus(container, e) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function mOpen() {
    if (!mnav) return;
    closeAll();
    mnav.classList.add('is-on');
    mnav.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pm-locked');
    if (mnavX) setTimeout(function () { mnavX.focus(); }, 60);
  }
  function mClose() {
    if (!mnav || !mnav.classList.contains('is-on')) return;
    mnav.classList.remove('is-on');
    mnav.setAttribute('aria-hidden', 'true');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    document.body.classList.remove('pm-locked');
  }

  if (burger) burger.addEventListener('click', function (e) { e.stopPropagation(); mOpen(); });
  if (mnavX)  mnavX.addEventListener('click', mClose);
  if (mnav) {
    mnav.addEventListener('click', function (e) { e.stopPropagation(); });
    mnav.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') trapFocus(mnav, e);
    });
  }

  /* ── Accordion nel menu mobile ── */
  function wireAccordion(btnId, subId) {
    var btn = document.getElementById(btnId);
    var sub = document.getElementById(subId);
    if (!btn || !sub) return;
    btn.addEventListener('click', function () {
      var on = btn.classList.toggle('is-open');
      sub.classList.toggle('is-on', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  wireAccordion('pm-mtech', 'pm-mtech-sub');
  wireAccordion('pm-macc', 'pm-msub');

  /* ── Escape chiude tutto ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAll();
    mClose();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-video-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pm-vd-section]').forEach(function (section) {
    var video = section.querySelector('.pm-vd__reel-card video');
    var btn   = section.querySelector('.pm-vd__reel-play');
    var bar   = section.querySelector('.pm-vd__reel-bar');

    if (!video || !btn) return;

    /* sync progress bar while video plays */
    if (bar) {
      video.addEventListener('timeupdate', function () {
        if (!video.duration) return;
        bar.style.width = ((video.currentTime / video.duration) * 100) + '%';
      });
    }

    /* play / pause on button click */
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });

    /* click anywhere on progress area to seek */
    var progress = section.querySelector('.pm-vd__reel-progress');
    if (progress) {
      progress.addEventListener('click', function (e) {
        if (!video.duration) return;
        var rect  = progress.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        video.currentTime = ratio * video.duration;
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
